import inicialState from './congelacao.state';
import * as actions from './congelacao.action';

const congelacaoReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.CONGELACAO_FINALIZADA:
      return {
        ...state,
        congelacaoFinalizada: action.payload.congelacaoFinalizada,
      };

    case actions.COLLAPSED_CONTAINER_EXAMES:
      return {
        ...state,
        collapseContainerExames: action.payload.collapseContainerExames,
      };
    default:
      return state;
  }
};

export default congelacaoReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/congelacao/congelacao.reducer.js